import { createAction, props } from '@ngrx/store';

export const loadIntegrations = createAction(
  '[Integrations] Load Integrations'
);

export const loadIntegrationsSuccess = createAction(
  '[Integrations] Load Integrations Success',
  props<{ data: any }>()
);

export const loadIntegrationsFailure = createAction(
  '[Integrations] Load Integrations Failure',
  props<{ error: any }>()
);

export const toggleQuickBooks = createAction(
  '[Integrations] toggleQuickBooks',
  props<{ active: boolean }>()
);

export const loadQuickBooks = createAction(
  '[Integrations] Load QuickBooks'
);

export const loadQuickBooksSuccess = createAction(
  '[Integrations] Load QuickBooks Success',
  props<any>()
);

export const loadQuickBooksFailure = createAction(
  '[Integrations] Load QuickBooks Failure',
  props<any>()
);
